<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-09-19 10:24:49
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-10-18 11:20:47
 * @FilePath: /epec-purchase-shopping-mall/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/home/workbench/components/e-tabs.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--  -->
<template>
  <div>
    <el-tabs
      v-model="currentActive"
      class="tabs-area"
      :type="tabsCard"
      @tab-click="handleTabClick"
    >
      <el-tab-pane
        v-for="item in paneList"
        :key="item.name"
        :label="item.label"
        :name="item.name"
      >
        <div slot="label" class="badge-slot">
          <el-badge
            :value="paneList.badgeNum"
            :max="99"
            class="item"
            :hidden="isHiddenBadge"
          >
            <span size="small" style="padding: 0 20px">{{ item.label }}</span>
          </el-badge>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'ETabs',

  components: {},
  props: {
    paneList: {
      type: Array,
      default() {
        return [];
      },
    },
    active: {
      type: [Number, String],
      default: 0,
    },
    isHiddenBadge: {
      type: Boolean,
      default: true,
    },
    tabsCard: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentActive: this.active,
    };
  },
  created() {},
  methods: {
    handleTabClick() {
      this.$emit('handleTabClick', this.currentActive);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  position: relative;
  background: rgba(244, 247, 255, 1);
  // border-top: 2px solid rgba(37, 135, 255, 1);
  &:before {
    content: '';
    width: 100%;
    height: 2px;
    background: rgba(37, 135, 255, 1);
    position: absolute;
    left: 0;
  }
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border-radius: 0;
}
</style>
